export default class Cookies {
	prefix = 'SW_CONSENT_BAR';

	cookies = {};

	constructor() {
		for (const c in window[this.prefix]) {
			this.cookies[c] = {...{
				type: 'marketing',
				title: '',
				description: '',
				cookieName: 'cookie_' + c,
				cookieValue: '1',
				callback: () => {},
				unload: () => {},
			}, ...window[this.prefix][c]};
		}
	}

	is (cookie = 'all') {
		if (cookie === 'all') {
			return this.get(this.prefix);
		}
		return false;
	}

	all(status = false) {
		if (status) {
			this.save(this.prefix, true);
		} else {
			this.save(this.prefix, false);
		}
	}

	save(name, val, expDays = 20) {
		let date = new Date();
		date.setTime(date.getTime() + (expDays * 86400000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + val + "; " + expires + "; path=/";
	}

	get(name) {
		name = name + "=";
		const cDecoded = decodeURIComponent(document.cookie);
		const cArr = cDecoded .split('; ');
		let cookie;
		cArr.forEach(val => {
			if (val.indexOf(name) === 0) {
				cookie = val.substring(name.length);
			}
		})

		return cookie;
  	}

	getTemplate() {
		let consentBar = `
			<div class="sw-consent-bar-configs col-12">
				<div class="row sw-consent-bar-configs-header">
					<div class="col-12">
						<b>Einstellungen:</b>
					</div>
				</div>
				${Object.keys(this.cookies).map(c => `
					<div class="row">
						<div class="col-12">
							<label for="sw-consent-bar-configs-${c}">
								<input${this.get(this.cookies[c].cookieName) === 'true' ? ' checked' : ''} type="checkbox" data-sw-consent-bar-configs="${this.cookies[c].cookieName}" id="sw-consent-bar-configs-${c}">
								${this.cookies[c].title}
							</label>
							<p class="sw-consent-bar-configs-description">${this.cookies[c].description}</p>
						</div>
					</div>
				`).join('')}
				<div class="sw-consent-bar-configs-buttons col">
					<div class="row">
						<div class="col">
							<button class="btn btn-primary sw-consent-bar-configs-button-acceptAll">Alle akzeptieren</button>
						</div>
						<div class="col">
							<button class="btn btn-primary sw-consent-bar-configs-button-save">Speichern</button>
						</div>
					</div>
				</div>
			</div>
		`;
		return consentBar;
	}
}
